import React, { useRef } from 'react';
import { l } from '../../../lang/index.jsx';
import Link from "../../menu-link/LinkHelper.jsx";

export default function About({navigate, lang, textMap}) {
    const containerRef = useRef(null);
    const t = (key) => textMap?.[key]?.[lang] || l(key, lang);

    return (
        <div key={lang} className="section section-home-about" ref={containerRef}>
            <h2 className="h2">{t('home-about-title')}</h2>
            <p className="reveal-type paragraph big-text" data-bg-color="transparent" data-fg-color="#fcfbe9">
                {t('home-about-1')}
            </p>
            <p className="reveal-type paragraph big-text text-2" data-bg-color="transparent" data-fg-color="#fcfbe9">
                {t('home-about-2')}
            </p>
            <div className="more-infos">
                <Link navigate={navigate} className='button' href={'/' + 'about'} aria-label="See the about page">
                    <span>{t('home-about-button')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                    </svg>
                </Link>
            </div>
        </div>
    );
}
